import React, { useContext } from 'react'
import { Link } from "gatsby"

import AutoCheckButton from '../autocheckButton/AutoCheckButton'
import FinanceCalculator from '../../Modules/financeCalculator'
import { ModalVehicleContext } from '../modal/storage/VehicleContext'
import fastLinkIcon from "../vdp/img/fastlink.jpg"

import { captureEvent } from 'event-service/modules/capture'

import unavaiable from '../../images/rv-not-available.png'
import InnerHTML from 'dangerously-set-html-content'
import { IsNewDisplay, IsCertifiedDisplay, configurableString, configurableLink, configurableSlug } from '../../Modules/configurableVehicleInfo'

export default function VehicleRecommendation(props) {
  const { theSlug, item, formatPrice, SRPCardBtns, overwriteCTAs, staticBtns, HideNewUsed} = props
  const { unavailableImg, AutoCheckEnabled } = props
  const isFavorite = props.isFavorite || false
  const favorite = props.favorite || (() => { })
  const location = typeof window !== 'undefined' && window.location
  const fallbackText = props.fallbackText
  const netPriceCustomText = props.netPriceCustomText || 'Net Price'
  const showSpecs = props.showSpecs 
  const showTrim = props.showTrim
  const axios = require('axios');


  const [, setFinanceModalContext] = useContext(ModalVehicleContext)

  const contextualizeItem = () => {
    const { Pricing, VehicleInfo } = item
    const finalPrice = Number(Pricing.ExtraPrice1 || Pricing.List)
    const vehicleInfo = VehicleInfo
    setFinanceModalContext({ finalPrice, vehicleInfo })
  }

  function getStorageItem(item) {
    return (typeof localStorage.getItem !== 'undefined' ? localStorage.getItem(item) : "[]")
  }

  function setStorageItem(item, value) {
    typeof localStorage.setItem !== 'undefined'
      ? localStorage.setItem(item, value)
      : console.log('no localStorage')
  }

  const handleImgError = (event) => {
    event.target.onerror = null;
    event.target.src = unavailableImg
  }

  const showPhoto = () => {
    let mainPhoto = {}
    if (item.ListOfPhotos.length === 0) {
      mainPhoto = {
        PhotoUrl: unavailableImg,
        Order: 1,
        VehiclePhotoID: item.VehicleInfo.VIN + "_unavaiable"
      }
    } else {
      mainPhoto = item.ListOfPhotos.filter(pic => { return pic.Order === 1 })[0];
    }
    return mainPhoto
  }

  const renderHTMLBtn = (html) => (
    <div className="sr-html-btns" data-vehicle-info={JSON.stringify({ ...item.VehicleInfo, price: item.Pricing.ExtraPrice1 })}>
      <InnerHTML html={configurableString(html, item.VehicleInfo)} />
    </div >
  )

  const renderBtns = (btngroup) => (
    <div className={`sr-btns dealer-${item.DealerID}`}>
      {(overwriteCTAs? staticBtns : SRPCardBtns).map((btngroup, index) => {
        let BtnStyle = btngroup.overrideTheme ? {
          background: btngroup.btncolor,
          border: '1px solid ' + btngroup.btntxtcolor,
          ":hover": {
            background: btngroup.btntxtcolor,
            border: '1px solid ' + btngroup.btncolor
          }
        } : {};
        let LinkStyle = btngroup.overrideTheme ? {
          color: btngroup.btntxtcolor,
          ":hover": { color: btngroup.btncolor }
        } : {};

        if (btngroup.html != undefined && btngroup.html != '' && btngroup.html != '<p></p>') {
          if (btngroup.html == "{{autocheck}}") {
            return <AutoCheckButton 
                        vin={item.VehicleInfo.VIN} 
                        IsNew={item.VehicleInfo.IsNew} 
                        AutoCheckEnabled={AutoCheckEnabled} 
                    />
          } else {
            return renderHTMLBtn(btngroup.html) //Test without make DM changes, Publishing, Clean & Building //renderHTMLBtn(btngroup.html) 
          }
        } else {
        return <div className={`sr-btns__wrap ${item.VehicleInfo.IsNew ? 'new-srp-card-wrap' : 'used-srp-card-wrap'}`}>
          {
            ((btngroup.btnleft !== "") && (btngroup.btnleftlink.includes('tel:')))
              ?
              <a className={`sr-btns-item  ${item.VehicleInfo.IsNew ? 'new-srp-btn-' + btngroup.btnleft.split(" ").join('-').toLowerCase() : 'used-srp-btn-' + btngroup.btnleft.split(" ").join('-').toLowerCase() }`} style={BtnStyle} href={btngroup.btnleftlink}
              onClick={event => {
                captureEvent({
                  event: 'asc_cta_interaction',
                  element_text: `${event.currentTarget.innerText}`,
                  element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                  element_type: 'button',
                  event_action: 'click',
                  event_action_result: `${btngroup.btnleftlink.startsWith("#") ? 'open form' : 'open'}`,
                  link_url: `${btngroup.btnleftlink}`,
                  item_id: item.VehicleInfo.VIN,
                  item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                  item_price: `${item.Pricing.ExtraPrice1}`,
                  item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                  item_year: `${item.VehicleInfo.Year}`,
                  item_make: `${item.VehicleInfo.Make}`,
                  item_model: `${item.VehicleInfo.Model}`,
                  item_variant: `${item.VehicleInfo.Trim}`,
                  item_color: `${item.VehicleInfo.ExteriorColor}`,
                  item_type: 'vehicle',
                  item_category: `${item.VehicleInfo.BodyStyle}`,
                  item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                  item_inventory_date: `${item.VehicleInfo.InStockDate}`
                }, {
                  handlers: ['ASC']
                }).then(res => console.log(res)).catch(err => console.log(err))
                  contextualizeItem(item);
                  setStorageItem("vehicle:vehicle", item.VehicleInfo);
                  setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                }
                }>
                <button className="sr-btns-link" style={LinkStyle} >
                  {configurableString(btngroup.btnleft, item.VehicleInfo)}
                </button>
              </a>
              :
              (btngroup.btnleft == "")
                ?
                <></>
                :
                ((btngroup.btnleft !== "") && (btngroup.btnleftlink.includes('#')))
                  ?
                  <Link className={`sr-btns-item  ${item.VehicleInfo.IsNew ? 'new-srp-btn-' + btngroup.btnleft.split(" ").join('-').toLowerCase() : 'used-srp-btn-' + btngroup.btnleft.split(" ").join('-').toLowerCase() }`} style={BtnStyle}
                    to={(location.search != undefined ? (location.search.includes('?') ? location.search : '?=' + location.search) : '?=') + configurableString(btngroup.btnleftlink, item.VehicleInfo)}
                    onClick={event => {
                      captureEvent({
                        event: 'asc_cta_interaction',
                        element_text: `${event.currentTarget.innerText}`,
                        element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                        element_type: 'button',
                        event_action: 'click',
                        event_action_result: `${btngroup.btnleftlink.startsWith("#") ? 'open form' : 'open'}`,
                        link_url: `${btngroup.btnleftlink}`,
                        item_id: item.VehicleInfo.VIN,
                        item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                        item_price: `${item.Pricing.ExtraPrice1}`,
                        item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                        item_year: `${item.VehicleInfo.Year}`,
                        item_make: `${item.VehicleInfo.Make}`,
                        item_model: `${item.VehicleInfo.Model}`,
                        item_variant: `${item.VehicleInfo.Trim}`,
                        item_color: `${item.VehicleInfo.ExteriorColor}`,
                        item_type: 'vehicle',
                        item_category: `${item.VehicleInfo.BodyStyle}`,
                        item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                        item_inventory_date: `${item.VehicleInfo.InStockDate}`
                      }, {
                        handlers: ['ASC']
                      }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <button className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnleft, item.VehicleInfo)}
                    </button>
                  </Link>
                  :
                  <Link className={`sr-btns-item  ${item.VehicleInfo.IsNew ? 'new-srp-btn-' + btngroup.btnleft.split(" ").join('-').toLowerCase() : 'used-srp-btn-' + btngroup.btnleft.split(" ").join('-').toLowerCase() }`} style={BtnStyle}
                    to={configurableLink(btngroup.btnleftlink, item.VehicleInfo)}
                    onClick={event => {
                    captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnleftlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnleftlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <button className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnleft, item.VehicleInfo)}
                    </button>
                  </Link>
          }
          {
            ((btngroup.btnright !== "") && (btngroup.btnrightlink.includes('tel:')))
              ?
              <a className={`sr-btns-item  ${item.VehicleInfo.IsNew ? 'new-srp-btn-' + btngroup.btnright.split(" ").join('-').toLowerCase() : 'used-srp-btn-' + btngroup.btnright.split(" ").join('-').toLowerCase() }`} style={BtnStyle} href={btngroup.btnrightlink}
                    onClick={event => {
                    captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnrightlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnrightlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                  contextualizeItem(item);
                  setStorageItem("vehicle:vehicle", item.VehicleInfo);
                  setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                }
                }>
                <button className="sr-btns-link" style={LinkStyle} >
                  {configurableString(btngroup.btnright, item.VehicleInfo)}
                </button>
              </a>
              :
              (btngroup.btnright == "")
                ?
                <></>
                :
                ((btngroup.btnright !== "") && (btngroup.btnrightlink.includes('#')))
                  ?
                  <Link className={`sr-btns-item  ${item.VehicleInfo.IsNew ? 'new-srp-btn-' + btngroup.btnright.split(" ").join('-').toLowerCase() : 'used-srp-btn-' + btngroup.btnright.split(" ").join('-').toLowerCase() }`} style={BtnStyle}
                    to={(location.search != undefined ? (location.search.includes('?') ? location.search : '?=' + location.search) : '?=') + configurableString(btngroup.btnrightlink, item.VehicleInfo)}
                    onClick={event => {
                    captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnrightlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnrightlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <button className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnright, item.VehicleInfo)}
                    </button>
                  </Link>
                  :
                  <Link className={`sr-btns-item  ${item.VehicleInfo.IsNew ? 'new-srp-btn-' + btngroup.btnright.split(" ").join('-').toLowerCase() : 'used-srp-btn-' + btngroup.btnright.split(" ").join('-').toLowerCase() }`} style={BtnStyle} to={configurableString(btngroup.btnrightlink, item.VehicleInfo)}
                    onClick={event => {
                    captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnrightlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnrightlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <button className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnright, item.VehicleInfo)}
                    </button>
                  </Link>
          }
        </div>
        }
      })}
    </div >
  )

  const FLAGS = { msrp: 1, msrpSale: 2, sale: 4, both: 8, incentives: 16 }
  const renderPrice = (msrp, sale) => {
    const toRender = 0
    if (msrp == 0 && sale == 0) {
      return toRender | FLAGS.both
    }  else if (msrp == sale) {
      return toRender | FLAGS.msrp
    } else if (msrp > sale) {
      return toRender | FLAGS.msrpSale
    } else if (msrp < sale) {
      return toRender | FLAGS.sale
    }
  }
  const pricing = renderPrice(item.Pricing.List, item.Pricing.ExtraPrice1)

  return (
    <>
      <div className="sr-item-slider">
        <Link to={configurableSlug(theSlug, item.VehicleInfo)}><img alt={configurableSlug("{{year}} {{make}} {{model}}", item.VehicleInfo)} className="sr-item__img" src={showPhoto().PhotoUrl} onError={handleImgError} />
          <div className="sr-item__more-btn">More Details</div></Link>
        <div className={`sr-item__like ${isFavorite && "sr-item__like_active"}`}
          onClick={() => favorite(item.VehicleInfo.VIN)} />
        {/*<ul className="sr-item-slider__dots">
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot"></li>
          <li className="sr-item-slider__dot sr-item-slider__dot_active"></li>
        </ul>*/
        }
      </div>
      <Link to={configurableSlug(theSlug, item.VehicleInfo)}><div className="sr-item-content">
        <div className={"sr-item-content__upper" + (!showSpecs && " sr-item-content__nospecs")} >
        <h2 className="sr-item-content__header">

          <span className="sr-item-content__header sr-item-content_font-normal">
            {HideNewUsed ? item.VehicleInfo.Year + " " : (IsNewDisplay(item.VehicleInfo.IsNew) + " " + item.VehicleInfo.Year + " ")}
          </span>
          {item.VehicleInfo.Make + " " + item.VehicleInfo.Model}
          {showTrim && " " + item.VehicleInfo.Trim}
        </h2>
          <p className="sr-item-content__stock">
           <span className="sr-item-content_font-normal, vin-content">VIN:</span> <span className="sr-item-content_font-normal vin-content sr-item-content-value, vin-content">{item.VehicleInfo.VIN}</span>
            <br />
            <span className="sr-item-content_font-normal, mileage-content">Mileage:</span> <span className="sr-item-content_font-normal mileage-content sr-item-content-value, mileage-content">{item.VehicleInfo.Mileage.toLocaleString()}</span>
            &nbsp;&#9679;&nbsp;
            <span className="sr-item-content_font-normal, stock-content">Stock #:</span> <span className="sr-item-content_font-normal stock-content sr-item-content-value, stock-content">{item.VehicleInfo.StockNumber}</span>
          {item.VehicleInfo.Engine.length > 0 ? <>
            <span style={{ display: "none" }} className="sr-item-content_font-normal engine-content"> 
              Engine: </span> 
              <span style={{ display: "none" }} className="sr-item-content_font-normal sr-item-content-value, engine-content">{item.VehicleInfo.Engine}</span>
           </> : <></>}
           {item.VehicleInfo.Transmission.length > 0 ? <>
            <span style={{ display: "none" }} className="sr-item-content_font-normal transmission-content">&nbsp;&#9679;&nbsp; Transmission: </span> 
            <span style={{ display: "none" }} className="sr-item-content_font-normal sr-item-content-value, transmission-content">{item.VehicleInfo.Transmission}</span>
          </> : <></>}

          </p>
          { showSpecs &&
            <p className="sr-item-content__specs">
            <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.Drivetrain}</span>, <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.Transmission}</span>, <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.Engine}</span>
            </p>
          }
          
        </div>

        {!item.VehicleInfo.IsNew ?
            <div className="sr-item-content__costs">
              <div className="sr-item-content__costs-new-cost">
                <h3 className="sr-item-content__cost-header netprice1">{netPriceCustomText}</h3>
                <p className="sr-item-content__cost">
                  {formatPrice(item.Pricing.ExtraPrice1, fallbackText)}
                </p>
              </div>
            </div>
            :
            <div className="sr-item-content__costs">
              {Boolean(pricing & FLAGS.both) &&
              <div className="sr-item-content__costs-msrp">
                <h3 className="sr-item-content__cost-header netprice2">{netPriceCustomText}</h3>
                <p className="sr-item-content__cost">{fallbackText}</p>
              </div>
              }
              {Boolean(pricing & FLAGS.msrp || pricing & FLAGS.msrpSale) &&
              <div className="sr-item-content__costs-msrp">
                <h3 className="sr-item-content__cost-header msrp1">MSRP</h3>
                <p className="sr-item-content__cost">
                  {formatPrice(item.Pricing.List, fallbackText)}
                </p>
              </div>
              }
              {(Boolean(pricing & FLAGS.sale || pricing & FLAGS.msrpSale) && item.Pricing.ExtraPrice1 > 0 ) &&
              <div className="sr-item-content__cost-header">
                <h3 className="sr-item-content__cost-header netprice3">{netPriceCustomText}</h3>
                <p className="sr-item-content__cost">
                  {formatPrice(item.Pricing.ExtraPrice1, fallbackText)}
                </p>
              </div>
              }
              {Boolean(pricing & FLAGS.incentives) &&
              <div className="sr-item-content__costs-msrp">
                <h3 className="sr-item-content__cost-header msrp2">MSRP</h3>
                <p className="sr-item-content__cost" style={{ fontSize: "1em", opacity: "0.55" }}>
                  {formatPrice(item.Pricing.List, fallbackText)}
                </p>
                <h3 className="sr-item-content__cost-header netprice4">{netPriceCustomText}</h3>
                <p className="sr-item-content__cost">
                  {formatPrice(item.Pricing.List - (item.Pricing.List - item.Pricing.ExtraPrice1), fallbackText)}
                </p>
              </div>
              }
            </div>
        }

      </div>
      </Link>
      {renderBtns(item)}
    </>
  )
}

VehicleRecommendation.defaultProps = {
  unavailableImg: unavaiable
}
